document.addEventListener('DOMContentLoaded', function () {
  var headerSections = document.querySelectorAll('[class*="custom-header-"]');

  headerSections.forEach(function (sectionRoot) {
    var openBtn = sectionRoot.querySelector('[data-open-drawer]');
    var closeBtn = sectionRoot.querySelector('[data-close-drawer]');
    var overlay = sectionRoot.querySelector('[data-overlay]');
    var drawer = sectionRoot.querySelector('[data-drawer]');
    var mobileToggles = sectionRoot.querySelectorAll('[data-mobile-toggle]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    mobileToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var targetId = this.getAttribute('aria-controls');
        var target = sectionRoot.querySelector('#' + targetId);
        var expanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        this.classList.toggle('is-open', !expanded);

        if (target) {
          target.hidden = expanded;
        }
      });
    });
  });
});